<template>
  <div v-if="inAccountVerification" class="popped-layout pt-xl activating-account flex">
    <preloader v-if="!accountVerified" title="Verifying Account..."></preloader>
    <div class="container h100 mx-auto flex flex-column align-center justify-center" v-else>
      <i class="text-green-4 fal fa-check-circle fa-3x"></i>
      <h4 class="text-green-4 font-rg m-0">
        {{localize('congratulations_account_is_verified')}}.
      </h4>
      <router-link to="/login" class="btn btn-primary text-gray-0 mt-xl">
        <span>Sign In</span>
        <i class="fal fa-chevron-right ml-s"></i>
      </router-link>
    </div>
  </div>  
  <wizard-wrap
      v-else
      class="pt-xl"
      v-bind:title="localize('new_mflow_reg')"
      title-note=""
      wizard-step-size="sm"
      :active-step="wizard.activeStep"
      :total-steps="wizard.totalSteps"
      @next-step="nextStep"
      @last-step="lastStep"
      :preloader="!dataSchema"
      :log="wizardLog"
      :wizard-msg-screen="wizardMsgScreen"
  >
    <wizard-nav
      slot="wizard-nav"
      :steps="wizard.steps"
      :valid-step="formIsValid"
      :active-step="wizard.activeStep"
      :total-steps="wizard.totalSteps"
      @step-clicked="stepCallback"
    ></wizard-nav>
    <div
      v-if="dataSchema"
      slot="wizard-steps"
      class="register wizard-active-step py-2xl container__sm"
    >
      <transition name="fast-fade" appear>
        <p v-if="wizard.activeStep !== 0" class="note Please use-fields-note mb-m">
          * {{localize('req_field')}}
        </p>
      </transition>
      <transition name="fade-slide" mode="out-in" appear>
        <!-- <keep-alive :include="['form-field']"> -->
        <div v-if="wizard.activeStep === 0" key="1" class="register-step--1">
          <h6 class="tcenter mb-s">{{localize('please_pick_opt')}}:</h6>
          <div class="flex justify-center align-center">
            <label
              class="visual-pick mr-xs"
              :class="!dataSchema.User.IsClinic ? 'active' : ''"
            >
              <input
                type="radio"
                name="accountType"
                hidden
                :value="false"
                v-model="dataSchema.User.IsClinic"
              />
              <!-- <i class="fad fa-user-md"></i> -->
              <!-- <img src="/img/dr.svg" alt="" /> -->
              <svg
                class="visual-pick-svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 74.85 75.07"
              >
                <path
                  class="cls-1"
                  d="M261.86,416.74a36,36,0,1,1,4.84,22.45s10.62-10.85,31.08-10.85a49.74,49.74,0,0,1,21.12,4.91"
                  transform="translate(-260.36 -383.22)"
                />
                <circle class="cls-1" cx="37.43" cy="28.86" r="13.91" />
                <path
                  class="cls-1"
                  d="M292.29,418.29c3.34,3,8.92,3.2,12-.34"
                  transform="translate(-260.36 -383.22)"
                />
              </svg>
              <span>{{localize('i_am_doctor')}}</span>
            </label>
            <label
              class="visual-pick ml-xs"
              :class="dataSchema.User.IsClinic ? 'active' : ''"
            >
              <input
                type="radio"
                name="accountType"
                hidden
                :value="true"
                v-model="dataSchema.User.IsClinic"
              />
              <!-- <i class="fad fa-clinic-medical"></i> -->
              <!-- <img src="/img/clinic.svg" alt="" /> -->
              <svg
                class="visual-pick-svg"
                id="Layer_1"
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 76.86 72.56"
              >
                <path
                  class="cls-1"
                  d="M294.64,441.41c1.67,0,1.91-2.21,1.9-3.2,0,0,.55-4.71,2.12-4.67s2.15,2.84,2.21,4.24a9.48,9.48,0,0,0,1,3.54c4.93.09,6.49-15.47,2.94-20.3a2.85,2.85,0,0,0-4.06-.7,3.89,3.89,0,0,1-4.22-.05,2.91,2.91,0,0,0-3.07.11c-1.23.69-4.54,7.63-2.56,13.42C291.62,435.83,292.57,441.41,294.64,441.41Z"
                  transform="translate(-259.35 -384.47)"
                />
                <path
                  class="cls-1"
                  d="M280,455.27a36.93,36.93,0,1,1,54.73-32.36"
                  transform="translate(-259.35 -384.47)"
                />
                <line
                  class="cls-1"
                  x1="21.12"
                  y1="71.06"
                  x2="21.12"
                  y2="41.49"
                />
                <line
                  class="cls-1"
                  x1="56.74"
                  y1="42.12"
                  x2="56.74"
                  y2="63.08"
                />
                <polyline
                  class="cls-1"
                  points="20.75 41.16 13.77 41.09 38.65 16.21 64.09 41.65 56.74 41.57"
                />
              </svg>
              <span>{{localize('we_are_clinic')}}</span>
            </label>
          </div>
        </div>
        <div
          v-else-if="wizard.activeStep === 1"
          key="2"
          class="register-step--2"
        >
          <div class="single" v-if="!dataSchema.User.IsClinic">
            <h5 class="strong">
              <!-- <i class="fal fa-user-nurse mr-xs"></i> -->

              <span>{{localize('dentist_info')}}</span>
            </h5>
            <form-field
              v-bind:label="localize('first_name')"
              v-model="dataSchema.User.FirstName"
              req
              @validate-field="updateValidHash"
              @remove-validation="removeFromValidHash"
              :dirty="solicitNextStep"
              rounded
              :locale = "locale"
              :maxlength="36"
            ></form-field>
            <form-field
              v-bind:label="localize('last_name')"
              v-model="dataSchema.User.LastName"
              :dirty="solicitNextStep"
              @validate-field="updateValidHash"
              @remove-validation="removeFromValidHash"
              req
              rounded
              :maxlength="36"
              :locale = "locale"
            ></form-field>
          </div>
          <div v-else class="flex-split">
            <div>
              <h5 class="strong">
                <!-- <i class="fal fa-clinic-medical mr-xs"></i> -->
                <span>{{localize('clinic_info')}}</span>
                <a class="note mx-m" href="#p" @click.prevent="lastStep">*{{localize('not_a_clinic')}}?</a
                >
              </h5>
              <form-field
                :locale = "locale"
                :maxlength="36"
                v-bind:label="localize('clinic_name')"
                @remove-validation="removeFromValidHash"
                v-model="dataSchema.User.ClinicName"
                :dirty="solicitNextStep"
                @validate-field="updateValidHash"
                req
                rounded
              ></form-field>
              <form-field
              :locale = "locale"
                @remove-validation="removeFromValidHash"
                v-bind:label="localize('Branch')"
                v-model="dataSchema.User.ClinicBranch"
                rounded
              ></form-field>
            </div>
            <div class="rel">
              <h5 class="strong font-rg">
                <!-- <i class="fal fa-user-nurse mr-xs"></i> -->
                <span>{{localize('dentist_list')}}</span>
              </h5>
              <div class="over-scroll-300">
                <field-group
                :locale = "locale"
                  v-for="(clinician, i) in dataSchema.ClinicSurgeons"
                  :key="clinician.id || i"
                  :group-index="i"
                  :fields="clinicianFields"
                  v-model="dataSchema.ClinicSurgeons[i]"
                  label-all-fields
                ></field-group>
              </div>
              <!-- <i @click="addDentist" class="add-dentist fal fa-user-plus"></i> -->

              <button @click.prevent="addDentist" class="btn add-dentist">
                <i class="fal fa-user-plus mx-xs"></i><span>{{localize('add_dentist')}}</span>
              </button>
            </div>
          </div>
        </div>
        <div
          v-else-if="wizard.activeStep === 2"
          key="3"
          class="register-step--3 rel"
        >

<!--           <div class="note abs corner-info">
            *{{localize('delivery_address_for_mguide')}}
          </div>
 -->          
          <div class="flex-split">
            <div>
              <h5 class="strong">
                {{localize('delivery_address_for_mguide')}}
                <!-- {{localize('Address')}} -->
              </h5>

              <div class="form-part--fields ratio-70-25">
                <form-field
                  :locale = "locale"
                  v-bind:label="localize('street')"
                  v-model="dataSchema.User.Street"
                  :dirty="solicitNextStep"
                  @validate-field="updateValidHash"
                  req
                ></form-field>
                <form-field
                  :locale = "locale"
                  v-bind:label="localize('house_no')"
                  v-model="dataSchema.User.StreetNo"
                  :err="!validateOnlyNumber(dataSchema.User.StreetNo)"
                  :err-msg="errMsgs.numbersOnly"
                  :dirty="solicitNextStep"
                  @validate-field="updateValidHash"
                  req
                ></form-field>
              </div>
              <div class="form-part--fields ratio-50-45">
                <form-field
                  :locale = "locale"
                  v-bind:label="localize('city')"
                  v-model="dataSchema.User.City"
                  :dirty="solicitNextStep"
                  @validate-field="updateValidHash"
                  req
                ></form-field>
                <!-- <form-field
                    label="Country"
                    v-model="dataSchema.User.Country"
                    req
                  ></form-field> -->
                <form-field
                  :locale = "locale"
                  v-if="countries && countries.length"
                  v-bind:label="localize('country')"
                  v-bind:select-placeholder="localize('country')"
                  field-type="select"
                  :select-options="countries"                  
                  v-model="dataSchema.User.Country"
                  :dirty="solicitNextStep"
                  multi
                  @validate-field="updateValidHash"
                  hide-label
                  req
                ></form-field>
                <form-field
                  :locale = "locale"
                  v-bind:label="localize('zip_code')"
                  v-model="dataSchema.User.ZipCode"
                  :dirty="solicitNextStep"
                  :err="zipcodeError"
                  :err-msg="zipcodeErrorMsg"
                  @validate-field="updateValidHash"
                  :minlength="2"
                  :maxlength="20"
                  req
                ></form-field>
                <form-field
                  :locale = "locale"
                  v-if="requiredState"
                  v-bind:label="localize('state')"
                  v-bind:select-placeholder="localize('state')"
                  field-type="select"
                  :select-options="states[dataSchema.User.Country]"                  
                  v-model="dataSchema.User.State"
                  :dirty="solicitNextStep"
                  multi
                  hide-label
                  :req="isUSA"
                  :err-msg="isUSA ? localize('this_fileld_required') : null"
                  @validate-field="updateValidHash"
                ></form-field>
                <form-field                  
                  v-else
                  v-bind:label="localize('state')"
                  :locale = "locale"
                  :class="[!!dataSchema.User.State ? 'has-value' : '']"
                  v-model="dataSchema.User.State"
                  :dirty="solicitNextStep"
                  @validate-field="updateValidHash"
                ></form-field>



                
              </div>
            </div>
            <div class="rel">
              <h5 class="strong">
                {{localize('contact_details')}}
              </h5>
              <div class="form-part--fields">
                <form-field
                  v-bind:label="localize('email')"
                  field-type="email"
                  v-model="dataSchema.User.Email"
                  :locale = "locale"
                  :validation="emailRx"
                  :server-validation="emailAvailable"
                  :err="!emailAvailable || !validUserEmail"
                  :valid="validUserEmail"
                  :valid-msg="
                    emailAvailable === true ? 
                    localize('email_is_available') : false
                  "
                  :err-msg="
                    validUserEmail && !emailAvailable
                      ? localize('email_has_account')
                      : localize('enter_valid_email')
                  "
                  valid-icon
                  :dirty="solicitNextStep || !emailAvailable"
                  @validate-field="updateValidHash"
                  req
                ></form-field>
                <form-field
                  field-type="phone"
                  v-bind:label="localize('phone_num')"
                  v-model="dataSchema.User.Phone"
                  :locale = "locale"
                  :dirty="solicitNextStep"
                  :err="phoneNumberError"
                  :err-msg="phoneNumberErrorMsg"
                  @validate-field="updateValidHash"
                  :minlength="8"
                  :maxlength="16"
                  req
                ></form-field>
              </div>

              <!-- {{mcenterOptions}} Mcenters -->
              <div>                
                 <form-field
                  :locale = "locale"
                  v-if="mcenterOptions && mcenterOptions.length"
                  v-bind:label="localize('Select Mcenter')"
                  field-type="select"
                  :select-options="mcenterOptions"
                  v-model="dataSchema.User.McenterID"
                  :dirty="solicitNextStep"
                  multi
                  @validate-field="updateValidHash"
                  hide-label
                  req
                ></form-field>             
                <label class="err-msg" v-if="mcenterOptions && mcenterOptions.length && dataSchema.User.McenterID<0">
                  <i class="fas fa-exclamation-circle mr-xs"></i><span>This field is required</span>                
                </label>                
              </div>
              

            </div>

            <div>
                <form-field
                  :locale = "locale"
                  v-bind:label="localize('i_own_an_active_msoft_license')"
                  field-type="checkbox"
                  v-model="IsProUser"
                  hide-label
                ></form-field>               
            </div>

            <!-- Select mcenter 
            <div>
                mcenters = {{mcenters}}
            </div>-->

          </div>
        </div>
        <div
          v-else-if="wizard.activeStep === 3"
          key="4"
          class="register-step--3 single"
        >
          <h5>{{localize('choose_your_password')}}:</h5>
          <div class="form-part--fields password-fields">
            <form-field
              field-type="password"
              v-bind:label="localize('enter_password')"
              :locale = "locale"
              v-model="dataSchema.User.Pass"
              :valid="!!dataSchema.User.Pass"
              :dirty="solicitNextStep"
              @validate-field="updateValidHash"
              @keyup.native.enter="submit"
              req
            >
              <password-meter
                slot="pswmeter"
                :password="dataSchema.User.Pass"
              />
            </form-field>
            <form-field
              field-type="password"
              v-bind:label="localize('confirm_password')"
              v-model="passConfirm"
              :err="
                !!dataSchema.User.Pass && dataSchema.User.Pass !== passConfirm
              "
              :valid="
                !!dataSchema.User.Pass && dataSchema.User.Pass === passConfirm
              "
              :err-msg="
                passConfirm ? localize('Password_not_match') : localize('field_is_required')
              "
              :locale = "locale"
              :disabled="!dataSchema.User.Pass"
              valid-icon
              :dirty="solicitNextStep"
              @validate-field="updateValidHash"
              @keyup.native.enter="submit"
              req
            ></form-field>
          </div>
        </div>
        <!-- </keep-alive> -->
      </transition>
    </div>
    
    <router-link
      slot="actions"
      class="block flex-none flex align-center line-1 note"
      to="/login"
    >
      <span class="text-gray-8 tright maxw-75">{{localize('login_to_my_account')}}</span>
      <i v-if="locale=='HE'" class="flex fas fa-2x fa-chevron-left mx-s"></i>
      <i v-else class="flex fas fa-2x fa-chevron-right mx-s"></i>
    </router-link>

    <a
      slot="wizard-links"
      class="flex mb-l align-baseline justify-center line-1 mx-auto"
      href="https://youtu.be/QTjbM_DQJHU"
      target="_blank"
    >
      <i class="fal fa-play-circle mx-xs"></i>
      <span>{{localize('how_to_video_signup')}}</span>
    </a>
  </wizard-wrap>
</template>
<script>
import { storage } from "@/utils";

// import { MazBtn, MazInput } from "maz-ui";
// import { MazPhoneNumberInput } from "maz-ui";
// console.log("MazPhoneNumberInput< ", MazPhoneNumberInput);
import WizardWrap from "@/components/WizardWrap.vue";
import WizardNav from "@/components/WizardNav.vue";

import PasswordMeter from "vue-simple-password-meter";
import FormField from "@/components/FormField.vue";
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "register",
  components: {
    // FieldGroup,
    PasswordMeter,
    FormField,
    WizardWrap,
    WizardNav
  },
  data() {
    return {      
      api: `${SERVER_API[ENV]}mflow/SignupInitData`,
      dataSchema: null,
      mcenterOptions:[],
      passConfirm: null,
      emailAvailable: "pending",
      IsProUser:false,
      accountVerified: false,
      verifyEmailScreen: false,
      // Toggle at every step for validations...
      solicitNextStep: false,
      wizard: {
        totalSteps: 3,
        activeStep: 0,
        steps: [
          {
            label: "Personal Information",
            hasSteps: [0, 1]
          },
          {
            label: "Contact Information",
            hasSteps: [2]
          },
          {
            label: "Security Setup",
            hasSteps: [3]
          }
        ]
      },
      accountTypes: [
        {
          label: "I am a Dentist",
          value: 1
        },
        {
          label: "We are a Clinic",
          value: 2
        }
      ],
      clinicianFields: [
        {
          id: 1,
          _prop: "first_name",
          label: "First Name",
          type: "text",
          req: true
        },
        {
          id: 2,
          _prop: "last_name",
          label: "Last Name",
          type: "text",
          req: true
        }
      ],
      errMsgs: {
        // required: "This field is required",
        numbersOnly: "Numbers only please",
        alphaNumbersOnly: "Numbers & letters only",
        noNumbers: "No Numbers allowed",
        phoneNumber: "Only characters allowed: 0-9().+_-]+"
      },
      states: {
        // CANADA
        38: [
          "AB",
          "BC",
          "MB",
          "NB",
          "NL",
          "NT",
          "NS",
          "NU",
          "ON",
          "PE",
          "QC",
          "SK",
          "YT"
        ],
        // USA
        226: [
          "AL",
          "AK",
          "AS",
          "AZ",
          "AR",
          "CA",
          "CO",
          "CT",
          "DE",
          "DC",
          "FM",
          "FL",
          "GA",
          "GU",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MH",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "MP",
          "OH",
          "OK",
          "OR",
          "PW",
          "PA",
          "PR",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UT",
          "VT",
          "VI",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY"
        ],
        // ITALY
        105: [
          "AG",
          "AL",
          "AN",
          "AO",
          "AR",
          "AP",
          "AT",
          "AV",
          "BA",
          "BT",
          "BL",
          "BN",
          "BG",
          "BI",
          "BO",
          "BS",
          "BR",
          "CA",
          "CL",
          "CB",
          "CE",
          "CT",
          "CZ",
          "CH",
          "CO",
          "CS",
          "CR",
          "KR",
          "CN",
          "EN",
          "FM",
          "FE",
          "FI",
          "FG",
          "FC",
          "FR",
          "GE",
          "GO",
          "GR",
          "IM",
          "IS",
          "SP",
          "AQ",
          "LT",
          "LE",
          "LC",
          "LI",
          "LO",
          "LU",
          "MC",
          "MN",
          "MS",
          "MT",
          "ME",
          "MI",
          "MO",
          "MB",
          "NA",
          "NO",
          "NU",
          "OR",
          "PD",
          "PA",
          "PR",
          "PV",
          "PG",
          "PU",
          "PE",
          "PC",
          "PI",
          "PT",
          "PN",
          "PZ",
          "PO",
          "RG",
          "RA",
          "RC",
          "RE",
          "RI",
          "RN",
          "RM",
          "RO",
          "SA",
          "SS",
          "SV",
          "SI",
          "SO",
          "SU",
          "BZ",
          "SR",
          "TA",
          "TE",
          "TR",
          "TP",
          "TN",
          "TV",
          "TS",
          "TO",
          "UD",
          "VA",
          "VE",
          "VB",
          "VC",
          "VR",
          "VV",
          "VI",
          "VT"
        ]
      }
    };
  },
  mounted() {

    this.wizard.steps[0].label = this.localize('personal_information');//Personal Information
    this.wizard.steps[1].label = this.localize('contact_information');//Contact Information
    this.wizard.steps[2].label = this.localize('security_setup');//Security Setup

    this.errMsgs.numbersOnly =      this.localize('num_only');//numbersOnly: "Numbers only please",
    this.errMsgs.alphaNumbersOnly = this.localize('nium_lettters_only');//Numbers & letters only
    this.errMsgs.noNumbers =        this.localize('no_num_allowrd');//numbersOnly: "No Numbers allowed",
    this.errMsgs.phoneNumber =      this.localize('only_chars') + ": 0-9().+_-]+";//numbersOnly: phoneNumber: "Only characters allowed: 0-9().+_-]+"

    this.clinicianFields[0].label = this.localize('first_name');
    this.clinicianFields[1].label = this.localize('last_name');

    this.updateShowTopBar(true);
    this.$on("validate-field", function(id, valid) {
      console.log("YES", id, valid);
    });
    if (this.inAccountVerification) {
      let vm = this;
      let t = this.$route.query.t;
      let id = this.$route.query.id;
      // let body = JSON.stringify({ id, t });
      let api = `${SERVER_API[ENV]}mflow/SignupActivate`;

      fetch(api + `?id=${id}&t=${t}`, {
        method: "post",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "pragma": "no-cache",
          "cache-control": "No-Store",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(res) {
          console.log("response from email verify >>> ", res);
          if (res === "ok" || res === "User email already verified") {
            vm.accountVerified = true;
          }
          // alert("res==" + res.title)
        })
        .catch(err => err);
    } else {
      if (this.userID) {
        this.wizard.activeStep = 1;
      }
      this.initDataSchema();
      // this.initValidationListeners();
    }
  },
  watch: {
    "wizard.activeStep"() {
      console.log("wizard.activeStep: ", this.wizard.activeStep);
      if (this.wizard.activeStep === 0) {
        this.clearValidHash();
        this.hasBeenSubmitted = false;
      }
    },
    validationArr() {
      if (this.validatedFieldCount === this.validationArr.length) {
        console.log("validation ar >", this.validationArr);
        this.hasBeenSubmitted = true;
      }
    },
    "dataSchema.User": {
      deep: true,
      handler: _.debounce(function() {
        console.log("this.hasBeenSubmitted: ", this.hasBeenSubmitted);
        if (this.hasBeenSubmitted) {
          console.log("revalidate");
          this.$eventHub.emit("force-validate");

          // this.validateFields();
        }
      }, 300)
    },
    "dataSchema.User.Country"() {
      this.dataSchema.User.State = null;
      this.countryChanged();
    },
    "dataSchema.User.Email": _.debounce(function() {
      let vm = this;
      vm.emailAvailable = "pending";
      if (this.validUserEmail && this.dataSchema) {
        return fetch(`${this.api}?email=${this.dataSchema.User.Email}`)
          .then(function(response) {
            return response.json();
          })
          .then(async function(json) {
            console.log("return from email check ", json);
            // vm.$set(vm, "emailAvailable", json === "ok" ? true : false);
            vm.emailAvailable = json === "ok" ? true : false;
            vm.$eventHub.emit("force-validate");
          });
      }
    }, 300)
  },
  methods: {
    ...mapActions(["updateShowTopBar"]),
    countryChanged()
    {
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////////
        this.mcenterOptions = [];
        this.dataSchema.User.McenterID = -1;
        
        var countryId = this.userCountryID;
        var countryName = "";
        var countryDefaultMcenterID = -1;        

        if(countryId<0){
          return false;
        }

        //find the selected country in the countries list:
        this.dataSchema.Countries.forEach(function(item) {
            if(item.CountryID && item.CountryID == countryId)
            {                
                countryName = item.Nicename;
                countryDefaultMcenterID = item.mcenter_id; //alert("Selcted country: "+countryId+" name:"+item.Nicename);
            }            
        });

        //get the list of mcenters related to the selected country
        var mcentersByCountry = this.dataSchema.Mcenters.filter((item) => item.McenterCountry === countryName);
        if(mcentersByCountry.length==0)
        {
            //get the default mcenter related to the country            
            mcentersByCountry = this.dataSchema.Mcenters.filter((item) => item.id === countryDefaultMcenterID);
        }

        if(mcentersByCountry && mcentersByCountry.length>0)
        {
          this.mcenterOptions =  mcentersByCountry.map(Mcenter => {
            return {
              label: Mcenter.McenterName,
              value: Mcenter.id
            };
          });

          if(this.mcenterOptions.length>0)
          {
            //Add first element
            var firstElement = {label:'Select Mcenter...',value:-1};
            this.mcenterOptions.unshift(firstElement);
          }
        }
    },
    initDataSchema() {
      let vm = this;

      let json = storage.get(`MFLOW__userDataSchema`, localStorage);
      if (!json) {
        return fetch(this.api)
          .then(function(response) {
            return response.json();
          })
          .then(async function(json) {
            console.log("return from apiL ", json);
            vm.dataSchema = json;
            storage.set(`MFLOW__userDataSchema`, json, localStorage);
          })
          .catch(err => err);
      }
      this.dataSchema = JSON.parse(json);
    },
    stepCallback(step, index) {
      let isStepBefore = this.wizard.activeStep > index;
      this.solicitNextStep = true;
      if (isStepBefore) {
        this.updateValidHash(false);
      }
      if (!this.formIsValid && !isStepBefore) {
        return;
      }
      this.updateValidHash(false);
      this.solicitNextStep = false;
      this.wizard.activeStep = index;
    },
    addDentist() {
      // let id = -1;
      let d = this.dataSchema.ClinicSurgeons;
      let id = d.length + 1;
      d.push({
        id,
        first_name: "",
        last_name: ""
      });
    },
    validateOnlyString(_string) {
      return /^[a-z]+$/i.test(_string);
    },
    validateOnlyNumber(_string) {
      return /^[0-9]+$/i.test(_string);
    },
    nextStep() {
      if(this.wizard.activeStep==2)
      {
        //add to validate the mcenter 
        if(this.mcenterOptions.length>0 && this.dataSchema.User.McenterID<0)
        {
            alert("Please select an Mcenter");
            this.formIsValid = false;
            return;
        }
      }

      this.solicitNextStep = true;
      if (!this.formIsValid) {
        return;
      }
      if (this.isFinalStep) {
        this.submit();
      } else {
        this.solicitNextStep = false;
        this.updateValidHash(false);
        this.wizard.activeStep++;
      }
    },
    lastStep() {
      this.solicitNextStep = false;
      this.updateValidHash(false);
      this.wizard.activeStep--;
    },
    submit() {
      let vm = this;
      console.log("SBUMIT REGISTRATION");
      let ClinicSurgeons = _.filter(
        this.dataSchema.ClinicSurgeons,
        d => d.first_name && d.last_name
      );
      let submit_data = {
        User: this.dataSchema.User,
        ClinicSurgeons
      };
      if (this.dataSchema.User.isClinic) {
        submit_data.User.FirstName = "";
        submit_data.User.LastName = "";
      }

      //Add PRO USER VALUE
      if (this.IsProUser) {
        submit_data.User.IsProUser = true;
      }else{
        submit_data.User.IsProUser = false;
      }
      
      //submit_data.User.IsProUser

      // this.validateFields();
      this.$eventHub.emit("force-validate");
      this.hasBeenSubmitted = true;
      this.$nextTick(function() {
        if (this.formIsValid) {
          console.log("FORM IS VALID");
          let body = JSON.stringify(submit_data);
          this.sendingToServer = true;
          fetch(this.api, {
            body,
            method: "post",
            mode: "cors",
            cache: "no-cache",
            headers: {
              "pragma": "no-cache",
              "cache-control": "No-Store",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*"
            }
          })
            .then(function(response) {
              return response.json();
            })
            .then(function(res) {
              console.log("res >>> ", res.title, " :: ", res);
              if (res === "User created successfully") {
                vm.sendingToServer = false;
                vm.verifyEmailScreen = true;
              } else if (res === "User with the same email already exists") {
                vm.sendingToServer = false;
              }
            })
            .catch(err => err);
        } else {
          console.log("FORM IS INVALID< ", this.formIsValid);
        }
      });
    }
  },
  computed: {
    ...mapGetters(["userID"]),
    ...mapState(["user","locale"]),
    wizardMsgScreen() {
      if (this.verifyEmailScreen) {
        return `
          <div class="container tcenter text-green-2 py-2xl"> 
          <i class='fal fa-paper-plane fa-3x'></i>
          <h3 class="text-green-3 my-xl">`+ this.localize('account_created_suc') +`.</h3>
          <h5>`+ this.localize('email_sent_to_you') +`,<br> 
          <strong>`+this.localize('click_ver_code')+`.</strong></h5>
          </div>
        `;
      }
      return null;
    },
    wizardLog() {
      if (this.sendingToServer) {
        return {
          type: "success",
          txt: this.localize('creating_account_wait'),//"Creating your account... please wait.",
          icon: "preloader"
        };
      } else if (this.hasBeenSubmitted && !this.formIsValid) {
        return {
          type: "err",
          txt: `You have ${this.invalidFields} invalid field${
            this.invalidFields.length > 1 ? "s" : ""
          }, please check.`,
          icon: "fas fa-lightbulb-exclamation"
        };
      } else if (this.hasBeenSubmitted && this.formIsValid) {
        return {
          type: "success",
          txt: this.localize('everything_looks_great'),// "Everything looks great!",
          icon: "fas fa-check-circle fa-2x"
        };
      }
      return null;
    },
    chosenCountry() {
      return this.dataSchema.User.Country;
    },
    isUSA() {
      return this.chosenCountry == "226";
    },
    isCanada() {
      return this.chosenCountry == "38";
    },
    isItaly() {
      return this.chosenCountry == "105";
    },
    requiredState() {
      // let chosenCountry = this.dataSchema.User.Country;
      return /(38|105|226)/.test(this.chosenCountry);
    },
    phoneNumberError() {
      if (this.isCanada || this.isUSA) {
        // CA || US
        return !this.validUsCaPhoneNumber(this.dataSchema.User.Phone);
      }
      return !this.validPhoneNumber(this.dataSchema.User.Phone);
    },
    phoneNumberErrorMsg() {
      let phone = this.dataSchema.User.Phone;
      if (this.isCanada || this.isUSA) {
        return "Please use format: 200 200 0000";
      }
      if (phone && phone.length < 8) {
        return this.localize('8_chars_required');// "Atleast 8 characters required.";
      }

      return this.errMsgs.phoneNumber;
    },
    zipcodeError() {
      if (this.isCanada) {
        return !this.validCAZipcode(this.dataSchema.User.ZipCode);
      } else if (this.isUSA) {
        // US
        return !this.validUSZipcode(this.dataSchema.User.ZipCode);
      }
      return !this.validAlphaNumbers(this.dataSchema.User.ZipCode);
    },
    zipcodeErrorMsg() {
      let zipcode = this.dataSchema.User.ZipCode;
      if (this.isUSA) {
        return "Please enter 5 digit number";
      } else if (this.isCanada) {
        return "Please use format: A1A 1A1";
      } else if (zipcode && zipcode.length && zipcode.length < 2) {
        return "Atleast 2 characters required.";
      }
      return this.errMsgs.alphaNumbersOnly;
    },
    inAccountVerification() {
      return _.has(this.$route.query, "t");
    },
    isFinalStep() {
      return this.wizard.activeStep === this.wizard.totalSteps;
    },
    userCountryID()
    {
        if(this.dataSchema.User.Country){
            return this.dataSchema.User.Country;
        }
        return -1;
    },
    selectedCountryName()
    {
        var countryObject = this.dataSchema.Countries.filter(item => item.CountryID === Number(this.userCountryID));
        return countryObject.Nicename;
    },
    mcenters()
    {
      if (this.dataSchema.Mcenters) 
      {
        //get the selected country 
        var countryObject = this.dataSchema.Countries.filter(item => item.CountryID === Number(this.userCountryID));
        ////alert("countryObject.Nicename="+countryObject.Nicename);
        var mcentersByCountry = this.dataSchema.Mcenters.filter((item) => item.McenterCountry === this.selectedCountryName);
        return mcentersByCountry.map(Mcenter => {
          return {
            label: Mcenter.McenterName,
            value: Mcenter.id
          };
        });
      }
      return null;
    },
    countries() {
      if (this.dataSchema.Countries) {
        return this.dataSchema.Countries.map(country => {
          return {
            label: country.Nicename,
            value: country.CountryID
          };
        });
      }
      return null;
    },
    validUserEmail() {
      return this.emailRx.test(this.dataSchema.User.Email);
    }
  }
};
</script>
<style lang="stylus">
.register .form-part--field
  margin-bottom 15px
.register .field-group .form-part--field
  margin-bottom 0 !important
.visual-pick
  width 230px
  height 230px
  background #fff
  border-bottom 1px solid rgba(blue_brand, 0)
  transform-style preserve-3d
  _flex(column, wrap, center, center)
  cursor pointer
  transition background 0.2s ease-out, border 0.2s ease-out
  & > span
    display block
    text-align center
    color gray_8
    font-size responsive 18px 20px
    transform translateZ(0)
    backface-visibility hidden
    marg('s', top)
    transition color 0.2s ease-out
  img
  svg
  i
    max-width 70%
    max-height 70%
    font-size 4vw
    display block
    margin 10px auto 0
    color blue_brand
    transform translate3d(0,0,0)
    will-change transform
    transition color 0.2s ease-out, transform 0.2s ease-out
  &:hover
    i
      transform translateY(-5%)
  &.active
    border-bottom 1px solid blue_brand
    // background blue_brand
    svg
    i
    span
      // fill #fff
      // color #fff
      transform translateY(-5%)



.corner-info
  top 0
  right 0
.btn.add-dentist
  appearance none
  border 1px solid blue_brand
  color blue_brand
  border-radius 34px
// .add-dentist
//   position absolute
//   bottom 0
//   right 0
//   transform translate(150%, -30px)
//   cursor pointer
//   color blue_brand
</style>

<style lang="stylus">
// SVG STYLES
.p-1,
.p-2
  fill none
  stroke #edf7f5
  stroke-linecap round
  stroke-miterlimit 10
.p-1
  stroke-width 4.8px
.p-2
  stroke-width 4.9px
.p-3
  fill #edf7f5
.pb-1
  fill none
  stroke #edf7f5
  stroke-linecap round
  stroke-miterlimit 10
  stroke-width 5.14px


.visual-pick-svg > *
  fill none
  stroke blue_brand
  stroke-linecap round
  stroke-linejoin round
  stroke-width 3px
  will-change stroke
  transition stroke 0.3s ease-out
  // /.active &
  //   stroke #fff
</style>



          